import { FC, memo } from 'react';
import { MdSearch } from 'react-icons/md';
import { Icon, Input } from '@chakra-ui/react';

import { InputGroup } from '../../../lib/chakraUi/components';
import { useDebouncedTextInput } from './hooks/useDebouncedTextInput';
import { DebouncedTextInputProps } from './types/DebouncedTextInputProps';

const DebouncedTextInputComponent: FC<DebouncedTextInputProps> = ({
  hasIcon = true,
  onDebouncedChange,
  ...props
}) => {
  const { search, handleInputChange } =
    useDebouncedTextInput(onDebouncedChange);
  return (
    <InputGroup
      startElement={hasIcon && <Icon as={MdSearch} />}
      startOffset="8px"
    >
      <Input
        placeholder="Search"
        variant="outline"
        {...props}
        onChange={handleInputChange}
        value={search}
      />
    </InputGroup>
  );
};

export const DebouncedTextInput = memo(DebouncedTextInputComponent);
